import AlertBody from "src/modules/3rd-party-management/pages/admin/compliance/monitoring/pages/alert-detail/components/alert-body";
import { useLocation } from "react-router-dom";

const MonitoringResultDetails = ({ id }) => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    return (
        <AlertBody
            id={id}
            supplierId={searchParams.get('supplierId')}
            type={searchParams.get('type')}
        />
    )
}

export default MonitoringResultDetails;